import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AssistantPage = () => {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen bg-[var(--app-bg)] px-4 py-6 text-[var(--app-text)] transition-colors duration-300 sm:px-6">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#00C4F0]">
              {t("assistant.eyebrow")}
            </p>
            <h1 className="text-3xl font-bold">{t("assistant.title")}</h1>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-[rgba(9,29,66,0.12)] px-4 py-2 text-sm font-semibold transition hover:scale-[1.02]"
          >
            <i className="ri-arrow-left-line text-base" />
            <span>{t("assistant.backToHome")}</span>
          </Link>
        </div>

        <section className="overflow-hidden rounded-[32px] border border-[rgba(9,29,66,0.08)] bg-white shadow-[0_24px_80px_rgba(9,29,66,0.08)] dark:border-[rgba(255,255,255,0.08)] dark:bg-[#0A1628] dark:shadow-none">
          <div className="flex min-h-[70vh] items-center justify-center px-6 py-16 text-center">
            <div className="max-w-md">
              <h2 className="text-xl font-semibold">{t("assistant.readyTitle")}</h2>
              <p className="mt-3 text-sm text-[color:rgba(9,29,66,0.7)] dark:text-[color:rgba(255,255,255,0.72)]">
                {t("assistant.readyDescription")}
              </p>
              <p className="mt-6 text-sm font-semibold uppercase tracking-[0.22em] text-[#00C4F0]">
                {t("assistant.title")}
              </p>
              <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-[rgba(9,29,66,0.12)] px-4 py-2 text-sm font-semibold dark:border-[rgba(255,255,255,0.12)]">
                <i className="ri-message-3-line text-base" />
                <span>{t("assistant.readyButtonLabel")}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default AssistantPage;
